import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext.jsx";
import {
  dismissSettingsWelcome,
  shouldShowSettingsWelcome,
} from "@/lib/settingsWelcomeState.js";

export default function useSettingsWelcomeGate(role, options = {}) {
  const auth = (typeof useAuth === "function" ? useAuth() : {}) || {};
  const location = useLocation();
  const userId = String(auth?.user?.id || auth?.profile?.user_id || "").trim();
  const [open, setOpen] = React.useState(false);
  const requireNavigationState = options?.requireNavigationState === true;
  const navigationAllowsWelcome = location.state?.showSettingsWelcome === true;

  React.useEffect(() => {
    const shouldOpen = shouldShowSettingsWelcome({
      userId,
      role,
      profile: auth?.profile || null,
    });
    setOpen(
      requireNavigationState ? shouldOpen && navigationAllowsWelcome : shouldOpen
    );
  }, [
    auth?.profile,
    navigationAllowsWelcome,
    requireNavigationState,
    role,
    userId,
  ]);

  const handleClose = React.useCallback(async () => {
    setOpen(false);
    if (!userId) return;
    await dismissSettingsWelcome(userId, role);
    if (typeof auth?.refreshProfile === "function") {
      await Promise.resolve(auth.refreshProfile()).catch(() => {});
    }
  }, [auth, role, userId]);

  return {
    open,
    name:
      auth?.profile?.display_name ||
      auth?.profile?.full_name ||
      auth?.user?.user_metadata?.full_name ||
      "",
    salutation:
      auth?.profile?.salutation ||
      auth?.user?.user_metadata?.salutation ||
      "",
    lastName:
      auth?.profile?.last_name ||
      auth?.user?.user_metadata?.last_name ||
      "",
    onClose: handleClose,
  };
}
